import { createMiddleware } from '@tanstack/react-start';

import { appendServerTimingMetric } from './server-timing.ts';

export interface ServerFnDebugMetadata {
	readonly dependencies?: readonly string[];
	readonly relatesTo: string;
}

function getServerFnDebugDescription({
	dependencies,
	relatesTo,
}: {
	readonly dependencies?: readonly string[];
	readonly relatesTo: string;
}): string {
	return `rel=${relatesTo};deps=${dependencies?.join('+') ?? 'none'}`;
}

export function createServerFnObservabilityMiddleware(metadata: ServerFnDebugMetadata) {
	return createMiddleware({ type: 'function' }).server(async ({ next, serverFnMeta }) => {
		const startTime = performance.now();
		const result = await next();
		const durationMs = performance.now() - startTime;
		const description = getServerFnDebugDescription(metadata);

		appendServerTimingMetric({
			description,
			durationMs,
			name: `sf-${serverFnMeta.name}`,
		});

		if (process.env.NODE_ENV !== 'production') {
			console.info('[ServerFn]', {
				dependencies: metadata.dependencies ?? [],
				durationMs: Number(durationMs.toFixed(2)),
				file: serverFnMeta.filename,
				name: serverFnMeta.name,
				relatesTo: metadata.relatesTo,
			});
		}

		return result;
	});
}
